import React from 'react';
import PropTypes from 'prop-types';
import { withContent } from 'components/Content';
import Slider from 'components/Slider';

const CONTENT_KEYS = {
  slider: 'Hero Slider',
};

const Hero = ({ content, className }) => (
  <div className={className}>
    <Slider content={content.slider} />
  </div>
);

Hero.propTypes = {
  content: PropTypes.object,
};

export default withContent(CONTENT_KEYS)(Hero);
